import http from '@utils/http'

/*
* 获取优惠券信息
**/
export function couponCollection(data): Promise<any> {
    return http.post('/sim/couponCollection', data || {})
}
/*
* 领取优惠券
**/
export function receiveCoupons(data): Promise<any> {
    return http.post('/sim/receiveCoupons', data || {})
}
/*
* 我的优惠券
**/
export function myCoupon(data): Promise<any> {
    return http.post('/sim/myCoupon', data || {})
}
/*
* 查询可用优惠券
**/
export function queryUseCoupon(data): Promise<any> {
    return http.post('/sim/queryUseCoupon', data || {})
}

/**
 * 我的兑换券
 * @param data
 * @returns {Promise<any>}
 */
export function myExchangeCoupon(data): Promise<any> {
    return http.post('/sim/myExchangeCoupon', data || {})
}
